import { useEffect } from 'react';
import type { Product } from '@skin-seoul/service';

interface UseProductDisplayProps {
  products: Product[];
  reviewStatsMap: Record<string, unknown>;
  accumulatedProducts?: Product[];
  accumulatedReviewStatsMap?: Record<string, unknown>;
  onProductsLoaded?: (products: Product[], reviewStatsMap: Record<string, unknown>) => void;
}

/**
 * Shared hook for handling product display logic and loading callbacks
 * Used by both SearchProductsGridContent and BrowseProductsGridContent
 */
export const useProductDisplay = ({
  products,
  reviewStatsMap,
  accumulatedProducts,
  accumulatedReviewStatsMap,
  onProductsLoaded,
}: UseProductDisplayProps) => {
  // Notify parent when products are loaded
  useEffect(() => {
    if (onProductsLoaded && products.length > 0) {
      onProductsLoaded(products, reviewStatsMap);
    }
  }, [products, reviewStatsMap, onProductsLoaded]);

  // Determine which products to display
  const displayProducts = accumulatedProducts && accumulatedProducts.length > 0 ? accumulatedProducts : products;
  const displayReviewStatsMap =
    accumulatedReviewStatsMap && Object.keys(accumulatedReviewStatsMap).length > 0
      ? accumulatedReviewStatsMap
      : reviewStatsMap;

  return {
    displayProducts,
    displayReviewStatsMap,
  };
};
